import STBoardCategories from "../../assets/styles/organisms/boardCategoriesForumPage.module.scss";
import { memo, useEffect, useState } from "react";
import { fetchBoardCategoriesForumPage } from "../../utils/api/fetchCategoriesForumPage";
import { useSwiperSettings } from "../../hooks/useSwiperSettings";
import "swiper/modules/navigation/navigation.scss";
import "swiper/modules/pagination/pagination.scss";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import "swiper/swiper.scss";
import STSwiper from "../../assets/styles/molecules/swiper.module.scss";
import { Pagination } from "swiper";
import { useHistory } from "react-router-dom";
import STButton from "../../assets/styles/atoms/button.module.scss";
import BoardCard from "../molecules/BoardCard";
import ForumLoadingPage from "../atoms/MessageBoardLoadingPage";
import SvgArrowRightMenuHeader from "../atoms/icons/ArrowRightMenuHeader";

type BoardProps = {
  id: number;
  title: string;
  content: string;
  nickname: string;
  total_of_likes: number;
  total_of_comments: number;
  avatar_url: string[];
  created_at: string;
  is_liked: boolean;
};

type BoardCategoriesProps = {
  id: number;
  title: string;
  description: string;
  color: string;
  children?: BoardProps[];
};
type BoardCardSwiperProps = {
  data: BoardProps[];
  componentKey: number;
};

const BoardCardSwiper = (props: BoardCardSwiperProps) => {
  const { data = [], componentKey } = props ?? {};
  const breakpoints = {
    default: {
      slidesPerView: 5,
      slidesPerGroup: 1,
      centeredSlides: false,
      loopThreshold: 5,
    },
    sp: {
      slidesPerView: window.innerWidth < 400 ? 1.6 : 1.8,
      slidesPerGroup: 1,
      centeredSlides: false,
      loopThreshold: 2,
    },
  };

  const dataLength = data.length || 0;
  const { slidesPerView, slidesPerGroup, centeredSlides } = useSwiperSettings(
    dataLength,
    breakpoints
  );

  if (!Array.isArray(data) || dataLength === 0) {
    return <></>;
  }

  return (
    <div className={STBoardCategories.boardList}>
      <Swiper
        modules={[Pagination]}
        spaceBetween={8}
        slidesPerView={slidesPerView}
        slidesPerGroup={slidesPerGroup}
        centeredSlides={centeredSlides}
        pagination={{
          clickable: true,
          el: `#pagination_board_category_${componentKey}`,
          bulletActiveClass: STSwiper.pagination_bullet_active_boards,
          bulletClass: STSwiper.pagination_bullet_boards,
        }}
      >
        {data?.map((child: any, index: number) => {
          const {
            id,
            avatar_url: avatarUrl = "",
            nickname,
            title,
            content,
            created_at: createdAt,
            image_urls: imageUrls,
            like_flag: likeFlag,
            number_of_comments: commentCount,
            comment_flag: commentFlag,
            number_of_likes: likeCount,
            board_category_id: categoryId,
            uid,
          } = child;
          const boardDetail = {
            id,
            avatarUrl,
            nickname,
            title,
            content,
            createdAt,
            imageUrls,
            likeFlag,
            commentCount,
            likeCount,
            categoryId,
            uid,
            commentFlag,
          };
          return (
            <SwiperSlide key={`board-slide-${child.id}-${index}`}>
              <BoardCard
                boardDetail={boardDetail}
                className="customBoardListForumCategoriesPage"
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
      <div
        id={`pagination_board_category_${componentKey}`}
        className={STSwiper.pagination_boards}
      ></div>
    </div>
  );
};

const BoardCategory = memo((props: BoardCategoriesProps) => {
  const { title, description, color, children = [], id } = props ?? {};
  const history = useHistory();

  const onNavigateToCategory = () => {
    history.push(`/message-board/categories/${id}`);
  };
  const renderBoardList = () => {
    if (Array.isArray(children) && children.length !== 0) {
      return <BoardCardSwiper data={children} componentKey={id} />;
    }
    return <div className={STBoardCategories.noData}>投稿はまだありません</div>;
  };
  return (
    <div className={STBoardCategories.category}>
      <div
        style={{ backgroundColor: color }}
        className={STBoardCategories.categoryHeader}
        onClick={onNavigateToCategory}
      >
        <div className={STBoardCategories.categoryInformation}>
          <span className={STBoardCategories.categoryTitle}>{title}</span>
          <span className={STBoardCategories.categoryDescription}>
            {description}
          </span>
        </div>
        <SvgArrowRightMenuHeader />
      </div>
      {renderBoardList()}
    </div>
  );
});

const BoardCategoriesForumPage = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [boardCategories, setBoardCategories] = useState<any>([]);
  const history = useHistory();
  useEffect(() => {
    const queryBoardCategoriesForumPage = async () => {
      try {
        const response = await fetchBoardCategoriesForumPage();
        if (!!response?.isSuccess) {
          setBoardCategories(response?.result);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    queryBoardCategoriesForumPage();
  }, []);

  const onNavigateToCreateBoardPage = () => {
    history.push("/message-board/board/create");
  };

  if (isLoading) {
    return <ForumLoadingPage className={STBoardCategories.container} />;
  }

  if (!Array.isArray(boardCategories) || boardCategories.length === 0) {
    return (
      <div className={STBoardCategories.emptyPage}>
        カテゴリーが存在しません。
      </div>
    );
  }

  return (
    <div className={STBoardCategories.container}>
      <button
        className={`${STBoardCategories.createBoardButton} ${STButton.primary}`}
        onClick={onNavigateToCreateBoardPage}
      >
        投稿する
      </button>
      <div className={STBoardCategories.listCategories}>
        {boardCategories.map((category: any) => {
          return <BoardCategory {...category} key={category.title} />;
        })}
      </div>
    </div>
  );
};

export default BoardCategoriesForumPage;
